export default {
      id: "arrow-left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }